/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, KONOIKE){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left_thin" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right_thin" /></svg></button>';

	// ===========================================================================
	// スライダー
	const mainSlider = () => {
		if($('.js-mainSlider').length) {
			$('.js-mainSlider').slick({
				infinite: true,
				speed: 1000,
				autoplay: true,
				fade: true,
				pauseOnHover: false,
				autoplaySpeed: 5000,
				slidesToShow: 1,
				arrows: false,
				dots: false,
			});
		}
	};

	// アニメーション
	const animation = () => {
		const anime = 'is-animation';
		$('.js-animation-h1').on('inview', (event, isInView) => {
			$('.js-animation-h1').addClass(anime);
		});

		$('.js-animation-block').each((idx, ele) => {
			$(ele).on('inview', (event, isInView) => {
				$(ele).addClass(anime);
			});
		});

		// ランダム表示画像
		const arrayShuffle = (arr) => {
			for(let i = (arr.length - 1); 0 < i; i--){
				let r = Math.floor(Math.random() * (i + 1));
				let tmp = arr[i];
				arr[i] = arr[r];
				arr[r] = tmp;
			}
			return arr;
		}
		$('.js-animation-bg._suffle').each((idx,ele) => {
			let imgArr = []
			let delay = 0;
			for(let i = 0; i < $(ele).find('li').length; i++) {
				imgArr.push(i);
			}
			let newArr = arrayShuffle(imgArr);
			for(let i = 0; i < newArr.length; i++) {
				delay += .2;
				$(ele).find('li').eq(newArr[i]).children('img').css('transition-delay', delay + 's');
			};
		});
	};


	// ==============================================================================
	mainSlider();
	animation();

})(window.jQuery, window.KONOIKE);
